import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'allKeysSameValue',
    standalone: false
})

export class AllKeysSameValuePipe implements PipeTransform {
    transform(dataObj: Record<string, number>, checkValue: number): boolean {
        return dataObj && Object.values(dataObj).every(value => value === checkValue);
    }
}